<template>
  <main class="invite-page">
    <AppNavBar
      class="invite-page__nav"
      :title="t('invite.title')"
      :border="false"
      :placeholder="false"
      :background-color="showNavSolid ? '#0c1d55' : 'transparent'"
      leftArrowColor="#fff"
      text-color="#ffffff"
    >
      <template #right>
        <button
          type="button"
          class="invite-page__nav-action"
          @click="openRewardDetails"
        >
          <app-image src="@/assets/images/homeImage/reward_icon.png" alt="" />
        </button>
      </template>
    </AppNavBar>

    <section
      class="invite-hero"
      :class="{ 'invite-hero--compact': isCompactHero }"
    >
      <div class="invite-hero__content">
        <button
          type="button"
          class="invite-hero__rules"
          @click="openReferralDocument"
        >
          {{ t("invite.pointsRules") }}
        </button>
        <h1 class="invite-hero__title">
          {{ t("invite.hero1") }}
          <span class="price">{{ t("invite.hero2") }}</span>
          <span>{{ t("invite.hero3") }}</span>
        </h1>
        <p class="invite-hero__desc">{{ t("invite.heroDesc") }}</p>
      </div>
      <app-image src="@/assets/images/homeImage/gift_icon.png" alt="" />
      <section ref="pointsCardRef" class="points-card">
        <div
          ref="pointsCarouselRef"
          class="points-card__carousel"
          :class="{ 'is-dragging': pointsDragging }"
          @mousedown="handlePointsMouseDown"
          @click.capture="handlePointsClickCapture"
        >
          <div
            v-for="card in levelCards"
            :key="card.label"
            class="points-card__item"
          >
            <article class="points-level-card" :style="card.cardStyle">
              <div
                v-if="card.isCurrent"
                class="points-level-card__tag"
                :style="{ background: card.tagColor, color: card.tagTextColor }"
              >
                {{
                  card.isPartner ? t("invite.partner") : t("mine.currentLevel")
                }}
              </div>

              <div class="points-level-card__body">
                <div class="points-level-card__title">
                  <app-image
                    class="points-level-card__icon"
                    :src="card.icon"
                    alt=""
                  />
                  <div data-strong :style="{ color: card.primaryColor }">
                    {{ card.label }}
                  </div>
                  <div
                    v-if="card.isPartner && !card.isCurrent"
                    class="points-level-card__join"
                    @click.stop="openPartnerQuestionnaire"
                  >
                    {{ t("invite.partnerJoinNow") }}
                  </div>
                </div>

                <!-- <div class="points-level-card__desc-wrap">
                  <p
                    class="points-level-card__desc"
                    :style="{ color: card.descColor }"
                  >
                    {{ card.hint }}
                  </p>
                </div> -->
                <div
                  class="points-level"
                  :class="{ 'points-level--hidden': card.isShowBar === false }"
                >
                  <div
                    class="points-level-card__bar"
                    :style="{ background: card.barBg }"
                  >
                    <i
                      :style="{
                        width: `${card.progress}%`,
                        background: card.barColor,
                      }"
                    />
                  </div>
                  <div class="hint" :style="{ color: card.descColor }">
                    {{ card.hint }}
                  </div>
                </div>

                <div class="points-level-card__foot">
                  <div
                    v-for="item in card.metrics"
                    :key="item.label"
                    class="points-level-card_list"
                    :style="{ color: card.descColor }"
                    @click="item.click"
                  >
                    <div class="points-level-card_item">
                      <div class="points-level-card_item-label">
                        <span>{{ item.label }}</span>
                        <span
                          v-if="item.icon"
                          class="points-level-card_item-icon"
                          aria-hidden="true"
                          >i</span
                        >
                      </div>
                      <div
                        :class="{
                          'points-level-card_item-value--zero': item.isCount,
                        }"
                      >
                        {{ item.value }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>
      <div class="invite-hero__claim">
        <div class="invite-hero__claim-label">
          {{ claimableAmountLabel }}
        </div>
        <div class="invite-hero__claim-row">
          <div data-strong>{{ claimableCommission }}</div>
          <van-button
            round
            type="primary"
            class="invite-hero__claim-button"
            :loading="claiming"
            :disabled="!canClaim || claiming"
            @click="claimReward"
          >
            {{ t("invite.pendingClaim") }}
          </van-button>
        </div>
      </div>
    </section>

    <section
      v-if="!isCurrentPartner"
      class="invite-card-bg"
      :style="{ backgroundImage: `url(${inviteIcon})` }"
      @click="openPartnerQuestionnaire"
    >
      <div class="invite-card-bg__content">
        <div class="invite-card-bg__title">
          {{ t("invite.partnerPromotion") }}
        </div>
        <div class="invite-card-bg__button">
          <span>{{ t("invite.partnerJoinNow") }}</span>
          <van-icon name="arrow" size="14" />
        </div>
      </div>
    </section>

    <!-- <section class="invite-card invite-card--first">
      <div class="card-title">
        <i />
        <h2>{{ t("invite.myExclusiveInvite") }}</h2>
      </div>

      <div class="invite-row">
        <span>{{ t("invite.invitationCodeShort") }}</span>
        <div class="invite-row__value">
          <div class="value">{{ invitationCodeText }}</div>
          <button type="button" @click="copyText(invitationCodeText)">
            <app-image src="@/assets/images/common_copy_icon_gray.png" alt="" />
          </button>
        </div>
      </div>

      <div class="invite-row">
        <span>{{ t("invite.invitationLinkShort") }}</span>
        <div class="invite-row__value invite-row__value--wide">
          <div class="value">{{ shortLink }}</div>
          <button type="button" @click="copyText(invitationLink)">
            <app-image src="@/assets/images/common_copy_icon_gray.png" alt="" />
          </button>
        </div>
      </div>

      <p class="invite-card__desc">
        {{ t("invite.invitationRelationTip") }}
      </p>
    </section> -->

    <section class="invite-card invite-reward-summary">
      <div class="reward-card-head">
        <div class="card-title reward-card-head__title">
          <i />
          <h2>{{ t("invite.commissionDetails") }}</h2>
        </div>
        <button
          type="button"
          class="reward-card-head__more"
          @click="openRewardDetails"
        >
          <span>{{ t("invite.viewFullRecords") }}</span>
          <van-icon name="arrow" />
        </button>
      </div>

      <div class="invite-reward-summary__list">
        <div class="invite-row" @click="openRecommendedUsers">
          <span>{{ t("invite.invitedFriendsTotal") }}</span>
          <div class="invite-row__value">
            <div class="value">
              {{ invitedFriendsTotal }} {{ t("invite.personUnit") }}
            </div>
          </div>
        </div>

        <div class="invite-row">
          <span>{{ t("invite.pendingCommission") }}</span>
          <div class="invite-row__value">
            <div class="value">{{ waitingCommission }} {{ rewardSymbol }}</div>
          </div>
        </div>

        <div class="invite-row invite-row--last">
          <span>{{ t("invite.totalCommission") }}</span>
          <div class="invite-row__value">
            <div class="value">{{ totalCommission }} {{ rewardSymbol }}</div>
          </div>
        </div>
      </div>
    </section>

    <section class="invite-card invite-card--recommender">
      <div class="card-title">
        <i />
        <h2>{{ t("invite.recommender") }}</h2>
      </div>

      <div class="invite-bind">
        <div
          class="invite-bind__field"
          :class="{ 'invite-bind__field--bound': isBound }"
        >
          <van-field
            v-model="parentCode"
            :readonly="isBound"
            :border="false"
            :placeholder="t('invite.enterRecommenderCode')"
          />
          <button
            v-if="!isBound"
            type="button"
            class="invite-bind__scan"
            :aria-label="t('invite.scanRecommenderCode')"
            @click="openScanner"
          >
            <app-image :src="scanCodeIcon" alt="" />
          </button>
        </div>
        <van-button
          :type="isBound ? 'default' : 'primary'"
          class="invite-bind__button"
          :class="{ 'invite-bind__button--bound': isBound }"
          :disabled="isBound"
          @click="bindParent"
        >
          {{ isBound ? t("invite.bound") : t("invite.bind") }}
        </van-button>
      </div>
    </section>

    <section class="invite-card">
      <div class="card-title">
        <i />
        <h2>{{ t("invite.inviteSteps") }}</h2>
      </div>

      <div
        v-for="(item, index) in steps"
        :key="item.text"
        class="step-row"
        :class="{ 'step-row--last': index === steps.length - 1 }"
      >
        <div class="step-row__icon">
          <app-image :src="item.icon" alt="" />
          <b v-if="index !== steps.length - 1" />
        </div>
        <span>{{ item.text }}</span>
      </div>
    </section>

    <div class="invite-bottom">
      <div class="invite-bottom__url-list">
        <div
          class="invite-bottom__url flex"
          @click="copyText(invitationCodeText)"
        >
          <span class="nowrap">{{ t("invite.invitationCodeShort") }}</span>
          <div class="url">
            <span class="black">{{ invitationCodeText }}</span>
            <AppSvgIcon
              v-if="inviteBottomCopyIcon"
              :src="inviteBottomCopyIcon"
              size="16"
              class="invite-bottom__url-icon"
            />
            <svg
              v-else
              class="invite-bottom__url-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              aria-hidden="true"
            >
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3.18033 7.18033C2.9398 7.42086 2.75 7.87397 2.75 8.8V11.2C2.75 12.126 2.9398 12.5791 3.18033 12.8197C3.42086 13.0602 3.87397 13.25 4.8 13.25H7.2C8.12603 13.25 8.57914 13.0602 8.81967 12.8197C9.0602 12.5791 9.25 12.126 9.25 11.2V8.8C9.25 7.87397 9.0602 7.42086 8.81967 7.18033C8.57914 6.9398 8.12603 6.75 7.2 6.75H4.8C3.87397 6.75 3.42086 6.9398 3.18033 7.18033ZM2.11967 6.11967C2.77914 5.4602 3.72603 5.25 4.8 5.25H7.2C8.27397 5.25 9.22086 5.4602 9.88033 6.11967C10.5398 6.77914 10.75 7.72603 10.75 8.8V11.2C10.75 12.274 10.5398 13.2209 9.88033 13.8803C9.22086 14.5398 8.27397 14.75 7.2 14.75H4.8C3.72603 14.75 2.77914 14.5398 2.11967 13.8803C1.4602 13.2209 1.25 12.274 1.25 11.2V8.8C1.25 7.72603 1.4602 6.77914 2.11967 6.11967Z" fill="black" />
              <path d="M6.16821 4C6.54097 4 6.83039 3.71547 7.01807 3.39341C7.06796 3.30779 7.12268 3.23796 7.18031 3.18033C7.42084 2.9398 7.87395 2.75 8.79998 2.75H11.2C12.126 2.75 12.5791 2.9398 12.8196 3.18033C13.0602 3.42086 13.25 3.87397 13.25 4.8V7.2C13.25 8.12603 13.0602 8.57914 12.8196 8.81967C12.762 8.8773 12.6922 8.93202 12.6066 8.98191C12.2845 9.16959 12 9.45901 12 9.83176C12 10.2952 12.4121 10.6657 12.8496 10.5127C13.2402 10.3761 13.5884 10.1722 13.8803 9.88033C14.5398 9.22086 14.75 8.27397 14.75 7.2V4.8C14.75 3.72603 14.5398 2.77914 13.8803 2.11967C13.2208 1.4602 12.274 1.25 11.2 1.25H8.79998C7.72601 1.25 6.77912 1.53979 6.11965 2.11965C5.82774 2.41156 5.62386 2.75977 5.48727 3.1504C5.33429 3.58789 5.70475 4 6.16821 4Z" fill="black" />
            </svg>
          </div>
        </div>
        <div class="invite-bottom__url" @click="copyText(invitationLink)">
          <span class="label">{{ t("invite.invitationLinkShort") }}</span>
          <div class="url">
            <span class="black">{{ shortLink }}</span>
            <AppSvgIcon
              v-if="inviteBottomCopyIcon"
              :src="inviteBottomCopyIcon"
              size="16"
              class="invite-bottom__url-icon"
            />
            <svg
              v-else
              class="invite-bottom__url-icon"
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              aria-hidden="true"
            >
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3.18033 7.18033C2.9398 7.42086 2.75 7.87397 2.75 8.8V11.2C2.75 12.126 2.9398 12.5791 3.18033 12.8197C3.42086 13.0602 3.87397 13.25 4.8 13.25H7.2C8.12603 13.25 8.57914 13.0609 8.81967 12.8197C9.0602 12.5791 9.25 12.126 9.25 11.2V8.8C9.25 7.87397 9.0602 7.42086 8.81967 7.18033C8.57914 6.9398 8.12603 6.75 7.2 6.75H4.8C3.87397 6.75 3.42086 6.9398 3.18033 7.18033ZM2.11967 6.11967C2.77914 5.4602 3.72603 5.25 4.8 5.25H7.2C8.27397 5.25 9.22086 5.4602 9.88033 6.11967C10.5398 6.77914 10.75 7.72603 10.75 8.8V11.2C10.75 12.274 10.5398 13.2209 9.88033 13.8803C9.22086 14.5398 8.27397 14.75 7.2 14.75H4.8C3.72603 14.75 2.77914 14.5398 2.11967 13.8803C1.4602 13.2209 1.25 12.274 1.25 11.2V8.8C1.25 7.72603 1.4602 6.77914 2.11967 6.11967Z" fill="black" />
              <path d="M6.16821 4C6.54097 4 6.83039 3.71547 7.01807 3.39341C7.06796 3.30779 7.12268 3.23796 7.18031 3.18033C7.42084 2.9398 7.87395 2.75 8.79998 2.75H11.2C12.126 2.75 12.5791 2.9398 12.8196 3.18033C13.0602 3.42086 13.25 3.87397 13.25 4.8V7.2C13.25 8.12603 13.0602 8.57914 12.8196 8.81967C12.762 8.8773 12.6922 8.93202 12.6066 8.98191C12.2845 9.16959 12 9.45901 12 9.83176C12 10.2952 12.4121 10.6657 12.8496 10.5127C13.2402 10.3761 13.5884 10.1722 13.8803 9.88033C14.5398 9.22086 14.75 8.27397 14.75 7.2V4.8C14.75 3.72603 14.4602 2.77914 13.8803 2.11967C13.2208 1.53979 12.2739 1.25 11.2 1.25H8.79998C7.72601 1.25 6.77912 1.53979 6.11965 2.11965C5.82774 2.41156 5.62386 2.75977 5.48727 3.1504C5.33429 3.58789 5.70475 4 6.16821 4Z" fill="black" />
            </svg>
          </div>
        </div>
      </div>
      <div class="invite-bottom__button">
        <van-button block round type="primary" @click="showShare">
          {{ t("invite.inviteNow") }}
        </van-button>
      </div>
    </div>

    <van-popup
      v-model:show="showPurchaseCommissionPopup"
      position="center"
      round
      class="purchase-commission-popup"
      overlay-class="purchase-commission-overlay"
      :close-on-click-overlay="false"
    >
      <section class="purchase-commission-dialog">
        <h2>{{ t("invite.purchaseCommissionTitle") }}</h2>
        <p class="purchase-commission-dialog__intro">
          {{ t("invite.purchaseCommissionIntro") }}
        </p>

        <div class="purchase-commission-dialog__item">
          <p>
            {{ t("invite.purchaseCommissionTip1") }}，{{
              t("invite.purchaseCommissionTip1Desc")
            }}
          </p>
        </div>
        <div class="purchase-commission-dialog__item">
          <p>
            {{ t("invite.purchaseCommissionTip2") }}，{{
              t("invite.purchaseCommissionTip2Desc")
            }}
          </p>
        </div>
        <div class="purchase-commission-dialog__item">
          <h3>
            {{ t("invite.purchaseCommissionTip3") }}，{{
              t("invite.purchaseCommissionTip3DescPrefix")
            }}<span class="purchase-commission-dialog__time">{{
              t("invite.purchaseCommissionTip3Time")
            }}</span
            >{{ t("invite.purchaseCommissionTip3DescSuffix") }}
          </h3>
          <p></p>
        </div>

        <van-button
          block
          round
          type="primary"
          class="purchase-commission-dialog__confirm"
          @click="showPurchaseCommissionPopup = false"
        >
          {{ t("invite.purchaseCommissionConfirm") }}
        </van-button>
      </section>
    </van-popup>

    <van-popup
      v-model:show="showConsumptionCommissionPopup"
      position="center"
      round
      class="consumption-commission-popup"
      overlay-class="purchase-commission-overlay"
      :close-on-click-overlay="false"
    >
      <section class="purchase-commission-dialog">
        <h2>{{ t("invite.consumptionCommissionTitle") }}</h2>
        <p class="purchase-commission-dialog__intro">
          {{ t("invite.consumptionCommissionIntro") }}
        </p>

        <div
          class="purchase-commission-dialog__item purchase-commission-dialog__item--inline"
        >
          <p>
            <span class="purchase-commission-dialog__emphasis">
              {{ t("invite.consumptionCommissionTip1") }}——
            </span>
            {{ t("invite.consumptionCommissionTip1Desc") }}
          </p>
        </div>
        <div
          class="purchase-commission-dialog__item purchase-commission-dialog__item--inline"
        >
          <p>
            <span class="purchase-commission-dialog__emphasis">
              {{ t("invite.consumptionCommissionTip2") }}——
            </span>
            {{ t("invite.consumptionCommissionTip2Desc") }}
            <br />
            <span class="purchase-commission-dialog__emphasis">
              {{ t("invite.consumptionCommissionTip2Partial") }}——
            </span>
            {{ t("invite.consumptionCommissionTip2PartialDesc") }}
          </p>
        </div>
        <div
          class="purchase-commission-dialog__item purchase-commission-dialog__item--inline"
        >
          <p>
            <span class="purchase-commission-dialog__emphasis">
              {{ t("invite.consumptionCommissionTip3") }}——
            </span>
            {{ t("invite.consumptionCommissionTip3Desc") }}
          </p>
        </div>

        <van-button
          block
          round
          type="primary"
          class="purchase-commission-dialog__confirm"
          @click="showConsumptionCommissionPopup = false"
        >
          {{ t("invite.purchaseCommissionConfirm") }}
        </van-button>
      </section>
    </van-popup>

    <van-popup
      v-model:show="showInvitePosterPopup"
      position="center"
      class="invite-poster-popup"
      :class="{ 'invite-poster-popup--compact': isShortViewport }"
      overlay-class="invite-poster-overlay"
      :close-on-click-overlay="false"
    >
      <section ref="invitePosterRef" class="invite-poster">
        <app-image class="invite-poster__art" :src="inviteOpenImage" alt="" />
        <app-image class="invite-poster__logo" :src="inviteLogo" alt="WinPay" />

        <h2 class="invite-poster__title">
          {{ t("invite.posterTitle") }}
        </h2>

        <div class="invite-poster__code">
          <div class="invite-poster__code-main">
            <div>
              <span>{{ t("invite.invitationCodeShort") }}：</span>
              <div class="invite-poster__code-value">
                {{ invitationCodeText }}
              </div>
            </div>
            <p>{{ t("invite.posterTagline") }}</p>
          </div>
          <div class="invite-poster__qrcode">
            <app-image v-if="qrUrl" :src="qrUrl" alt="" />
          </div>
        </div>
      </section>
    </van-popup>

    <van-popup
      v-model:show="showSharePopup"
      position="bottom"
      :overlay="false"
      @close="closesPopup"
      class="share-popup"
      :class="{ 'share-popup--compact': isShortViewport }"
    >
      <div class="share-popup__header">
        <span />
        <h3>{{ t("invite.share") }}</h3>
        <button type="button" @click="closeSharePopup">
          <app-image
            class="app-cancel-icon"
            src="@/assets/images/cancel_gray.png"
            alt=""
          />
        </button>
      </div>

      <div class="share-popup__rows">
        <div class="share-popup__row">
          <span>{{ t("invite.invitationCodeShort") }}</span>
          <div>
            <div class="share-popup__value">{{ invitationCodeText }}</div>
            <button type="button" @click="copyText(invitationCodeText)">
              <app-image
                src="@/assets/images/common_copy_icon_gray.png"
                alt=""
              />
            </button>
          </div>
        </div>
        <div class="share-popup__row">
          <span>{{ t("invite.invitationLinkShort") }}</span>
          <div>
            <div class="share-popup__value">{{ shortLink }}</div>
            <button type="button" @click="copyText(invitationLink)">
              <app-image
                src="@/assets/images/common_copy_icon_gray.png"
                alt=""
              />
            </button>
          </div>
        </div>
      </div>

      <div class="share-popup__actions">
        <div class="share-popup__icon" @click="downloadQrCode">
          <span><van-icon :name="arrowDownLogo" /></span>
          {{ t("invite.saveImage") }}
        </div>
        <div class="share-popup__icon" @click="copyText(invitationLink)">
          <span><van-icon :name="copyLogo" /></span>
          {{ t("invite.copyUrl") }}
        </div>
      </div>
    </van-popup>
  </main>
</template>

<script setup>
import { computed, nextTick, onMounted, onUnmounted, ref, watch } from "vue";
import QRCode from "qrcode";
import html2canvas from "html2canvas";
import {
  closeToast,
  showConfirmDialog,
  showFailToast,
  showLoadingToast,
  showSuccessToast,
  showToast,
} from "vant";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { userGetUserInfoByAddress } from "@/api/auth";
import { useWalletScanner } from "@/composables/useWalletScanner";
import { copyToClipboard } from "@/utils/clipboard";
import { formatCardTimestamp } from "@/view/card/utils";
import { getRouteState, navigateWithState } from "@/utils/route-state";
import {
  ptBindParent,
  ptInfo,
  refDoc,
  refOverview,
  refRewardClaim,
} from "@/api/wallet";
import { useProfileStore } from "@/stores/profile";
import { useInviteRewardStore } from "@/stores/invite-reward";
import { useWebModalStore } from "@/stores/web-modal";
import AppSvgIcon from "@/components/AppSvgIcon.vue";
import stepOneIcon from "@/assets/images/homeImage/invite_icon_one.png";
import stepTwoIcon from "@/assets/images/homeImage/invite_icon_two.png";
import stepThreeIcon from "@/assets/images/homeImage/invite_icon_three.png";
import pointCardOneIcon from "@/assets/images/settingImage/pointCard_one_icon.png";
import pointCardTwoIcon from "@/assets/images/settingImage/pointCard_two_icon.png";
import pointCardThreeIcon from "@/assets/images/settingImage/pointCard_three_icon.png";
import pointCardFourIcon from "@/assets/images/settingImage/pointCard_four_icon.png";
import scanCodeIcon from "@/assets/images/common_scancode_icon3.png";
import inviteBottomCopyIcon from "@/assets/images/SVG/icon/copy.svg";
import inviteIcon from "@/assets/images/Invite/img_invite.png";
import inviteOpenImage from "@/assets/images/Invite/img_open.png";
import inviteLogo from "@/assets/images/Invite/img_logo.svg";
import arrowDownLogo from "@/assets/images/Invite/img_arrow_down.svg";
import copyLogo from "@/assets/images/Invite/img_copy.svg";

const { t, locale } = useI18n();
const route = useRoute();
const router = useRouter();
const { openWalletScanner } = useWalletScanner();
const profileStore = useProfileStore();
const rewardStore = useInviteRewardStore();
const webModalStore = useWebModalStore();
const pageState = computed(() => getRouteState(route, "wallet-invite", {}));

const inviteOverview = ref({});
const referralDocument = ref({});
const parentCode = ref("");
const userNum = ref("--");
const showSharePopup = ref(false);
const showInvitePosterPopup = ref(false);
const showPurchaseCommissionPopup = ref(false);
const showConsumptionCommissionPopup = ref(false);
const qrUrl = ref("");
const handledScanValue = ref("");
const showNavSolid = ref(false);
const openingReferralDocument = ref(false);
const openingPartnerQuestionnaire = ref(false);
const claiming = ref(false);
const isShortViewport = ref(false);
const pointsCardRef = ref(null);
const pointsCarouselRef = ref(null);
const pointsDragging = ref(false);
const invitePosterRef = ref(null);
let pointsMouseState = null;
let suppressPointsClick = false;
let suppressPointsClickTimer = null;

const invitationCodeText = computed(() =>
  String(inviteOverview.value?.invitationCode || "--"),
);
const isBound = computed(() => Number(inviteOverview.value?.isBind || 0) === 1);
const rewardPreviewList = computed(() => rewardStore.previewList);
const rewardSymbol = computed(
  () => String(inviteOverview.value?.symbol || "USDT").trim() || "USDT",
);
const claimableAmountLabel = computed(() =>
  t("invite.claimableAmount").replace("USDT", rewardSymbol.value),
);
const invitedFriendsTotal = computed(() =>
  String(inviteOverview.value?.inviteCnt ?? 0),
);
const claimableCommission = computed(
  () => inviteOverview.value?.claimableAmount,
);
const canClaim = computed(() => Number(claimableCommission.value) > 0);
const waitingCommission = computed(() => inviteOverview.value?.waitingAmount);
const totalCommission = computed(() => inviteOverview.value?.totalAmount);
const invitationLink = computed(
  () => String(inviteOverview.value?.invitationUrl || "--").trim() || "--",
);
const referralDocumentUrl = computed(() =>
  String(referralDocument.value?.url || "").trim(),
);
const partnerQuestionnaireUrl = computed(() =>
  String(referralDocument.value?.questionnaireUrl || "").trim(),
);
const questionnaireLanguage = computed(() =>
  String(locale.value || profileStore.locale || "zh-CN"),
);
const isCompactHero = computed(() =>
  ["zh-CN", "zh-HK", "en-US"].includes(
    String(locale.value || profileStore.locale || "zh-CN"),
  ),
);
const shortLink = computed(() => truncateLink(invitationLink.value));
const steps = computed(() => [
  { icon: stepOneIcon, text: t("invite.step1") },
  { icon: stepTwoIcon, text: t("invite.step2") },
  { icon: stepThreeIcon, text: t("invite.step3") },
]);

const levelList = computed(() => {
  const levels = Array.isArray(inviteOverview.value?.levels)
    ? inviteOverview.value.levels
    : [];
  return [...levels].sort(
    (left, right) => Number(left?.level || 0) - Number(right?.level || 0),
  );
});

const currentLevelIndex = computed(() => {
  const index = levelList.value.findIndex(
    (level) => Number(level?.current) === 1,
  );
  return index >= 0 ? index : 0;
});
const isCurrentPartner = computed(
  () => Number(levelList.value[currentLevelIndex.value]?.partner) === 1,
);

function appendQuestionnaireParams(url) {
  const value = String(url || "").trim();
  if (!value) {
    return "";
  }

  const params = [
    ["lang", questionnaireLanguage.value],
    ["userId", userNum.value],
  ]
    .filter(([, paramValue]) => paramValue && paramValue !== "--")
    .map(
      ([key, paramValue]) => `${key}=${encodeURIComponent(String(paramValue))}`,
    )
    .join("&");
  if (!params) {
    return value;
  }

  const separator = value.includes("?")
    ? value.endsWith("?") || value.endsWith("&")
      ? ""
      : "&"
    : "?";
  return `${value}${separator}${params}`;
}

function openPurchaseCommissionPopup() {
  showPurchaseCommissionPopup.value = true;
}

function openConsumptionCommissionPopup() {
  showConsumptionCommissionPopup.value = true;
}

function formatRewardAmount(value) {
  const amount = Number(value);
  return Number.isFinite(amount) ? amount : "0.00";
}

function getLevelProgressValue(count, minCount) {
  const requiredCount = Number(minCount);
  if (!Number.isFinite(requiredCount) || requiredCount <= 0) {
    return 100;
  }
  return Math.min(100, Math.max(0, (Number(count || 0) / requiredCount) * 100));
}

function getLevelHintText(count, minCount = 0) {
  const requiredCount = Number(minCount);
  if (!Number.isFinite(requiredCount) || requiredCount < 0) {
    return String(count || 0);
  }
  return `${count || 0}/${requiredCount}`;
}

const levelCards = computed(() => {
  const invitedCount = Number(inviteOverview.value?.refCnt || 0);
  const styles = [
    {
      icon: pointCardOneIcon,
      primaryColor: "#26248a",
      descColor: "#3135AC",
      barBg: "#cfdcff",
      barColor: "#3135AC",
      tagColor: "#4343b3",
      tagTextColor: "#ffffff",
      cardStyle: {
        background: "linear-gradient(180deg, #d7e2ff 0%, #ffffff 100%)",
        boxShadow: "0 2px 3px rgba(50, 55, 173, 0.10)",
      },
    },
    {
      icon: pointCardTwoIcon,
      primaryColor: "#234796",
      descColor: "#3e67c0",
      barBg: "#b3dcff",
      barColor: "#234796",
      tagColor: "#234796",
      tagTextColor: "#ffffff",
      cardStyle: {
        background: "linear-gradient(180deg, #aed9ff 0%, #ffffff 100%)",
        boxShadow: "0 2px 3px rgba(223, 240, 255, 1)",
      },
    },
    {
      icon: pointCardThreeIcon,
      primaryColor: "#b15921",
      descColor: "#e08449",
      barBg: "#f9e5c3",
      barColor: "#b15921",
      tagColor: "#b15921",
      tagTextColor: "#ffffff",
      cardStyle: {
        background: "linear-gradient(180deg, #fce8c3 0%, #ffffff 100%)",
        boxShadow: "0 2px 3px rgba(246, 198, 113, 0.20)",
      },
    },
  ];
  const partnerStyle = {
    icon: pointCardFourIcon,
    primaryColor: "#ffeaa3",
    descColor: "#ffeaa3",
    barBg: "#8d8c8c",
    barColor: "#ffeaa3",
    tagColor: "#ffeaa3",
    tagTextColor: "#414141",
    cardStyle: {
      background: "#4e4d4d",
      boxShadow: "none",
    },
  };

  return levelList.value.map((level, index) => {
    const isPartner = Number(level?.partner) === 1;
    const isLast = index === levelList.value.length - 1;
    const style = isPartner ? partnerStyle : styles[index % styles.length];
    const minCount = Number(level?.minCnt || 0);

    return {
      ...style,
      label: String(level?.name || `LV.${level?.level || index + 1}`),
      isCurrent: Number(level?.current) === 1,
      isPartner,
      isShowBar: !isLast,
      progress: getLevelProgressValue(invitedCount, minCount),
      hint: getLevelHintText(invitedCount, minCount),
      metrics: [
        {
          label: t("invite.purchaseCommission"),
          icon: "info-o",
          click: openPurchaseCommissionPopup,
          value: String(level?.openRatePercent || "0%"),
        },
        {
          label: t("invite.consumptionCommission"),
          icon: "info-o",
          click: openConsumptionCommissionPopup,
          value: String(level?.useRatePercent || "0%"),
        },
        {
          label: t("invite.invitationTotal"),
          isCount: true,
          click: openRecommendedUsers,
          value: String(invitedCount),
        },
      ],
    };
  });
});

function truncateLink(value) {
  const text = String(value || "").trim();
  if (!text || text === "--") {
    return "--";
  }
  if (text.length <= 10) {
    return text;
  }
  return `${text.slice(0, 5)}...${text.slice(-5)}`;
}

async function copyText(text) {
  const value = String(text || "").trim();
  if (!value || value === "--") {
    return;
  }
  const copied = await copyToClipboard(value);
  if (copied) {
    showSuccessToast(t("wallet.copySuccess"));
    return;
  }
  showFailToast(t("wallet.copyFailed"));
}

function openScanner() {
  openWalletScanner({
    back: "/wallet/invite",
    stateNamespace: "wallet-invite",
    statePayload: { ...pageState.value },
  });
}

function openRewardDetails() {
  navigateWithState(router, "/wallet/invite/reward", {
    namespace: "wallet-invite-reward",
    payload: {
      overview: inviteOverview.value,
    },
  });
}

function openRecommendedUsers() {
  router.push("/wallet/invite/recommended-users");
}

async function openReferralDocument() {
  if (openingReferralDocument.value) {
    return;
  }

  openingReferralDocument.value = true;
  try {
    const url = referralDocumentUrl.value || (await loadReferralDocument(true));
    if (!url) {
      showFailToast(t("common.retryLater"));
      return;
    }

    webModalStore.open({
      url,
      title: t("invite.pointsRules"),
      navBackgroundColor: "#fff",
    });
  } catch (error) {
    showFailToast(error?.message || t("common.retryLater"));
  } finally {
    openingReferralDocument.value = false;
  }
}

async function openPartnerQuestionnaire() {
  if (openingPartnerQuestionnaire.value) {
    return;
  }

  openingPartnerQuestionnaire.value = true;
  try {
    if (!partnerQuestionnaireUrl.value) {
      await loadReferralDocument(true);
    }

    if (!userNum.value || userNum.value === "--") {
      const userInfo = await ptInfo(
        { address: profileStore.platformAddress || null },
        { meta: { showLoading: false } },
      );
      userNum.value = String(userInfo?.userNum ?? "");
    }

    const url = appendQuestionnaireParams(partnerQuestionnaireUrl.value);
    if (!url) {
      showFailToast(t("common.retryLater"));
      return;
    }

    webModalStore.open({
      url,
      title: t("invite.partnerJoinNow"),
      navBackgroundColor: "#fff",
    });
  } catch (error) {
    showFailToast(error?.message || t("common.retryLater"));
  } finally {
    openingPartnerQuestionnaire.value = false;
  }
}

async function loadReferralDocument(showLoading = false) {
  const address = profileStore.platformAddress || null;
  if (!address) {
    referralDocument.value = {};
    return "";
  }

  const result = await refDoc(
    {
      address,
      lang: locale.value || profileStore.locale || "zh-CN",
    },
    { meta: { showLoading } },
  );
  referralDocument.value = result || {};
  return referralDocumentUrl.value;
}

async function claimReward() {
  if (!canClaim.value || claiming.value) {
    return;
  }

  const address = profileStore.platformAddress || null;
  const coinId = inviteOverview.value?.coinId;
  const lang = locale.value || profileStore.locale || "zh-CN";
  if (!address || coinId === null || coinId === undefined || coinId === "") {
    showToast({
      message: t("common.retryLater"),
      icon: "close",
      wordBreak: "normal",
    });
    return;
  }

  claiming.value = true;
  try {
    await refRewardClaim(
      { address, coinId, lang },
      { meta: { showLoading: false } },
    );

    try {
      inviteOverview.value =
        (await refOverview(
          { address, lang },
          { meta: { showLoading: false } },
        )) || {};
    } catch (_) {
      // The claim succeeded; the next page refresh will reload the overview.
    }

    showToast({
      message: t("invite.claimSuccess"),
      icon: "success",
      wordBreak: "normal",
    });
  } catch (_) {
    // API errors are displayed by the shared HTTP interceptor with showToast.
  } finally {
    claiming.value = false;
  }
}

const showShare = () => {
  syncPopupViewport();
  showInvitePosterPopup.value = true;
  showSharePopup.value = true;
};

function syncPopupViewport() {
  const viewportHeight = Number(
    window.visualViewport?.height || window.innerHeight || 0,
  );
  isShortViewport.value = viewportHeight > 0 && viewportHeight <= 800;
}

const closesPopup = () => {
  showInvitePosterPopup.value = false;
  showSharePopup.value = false;
};

function closeSharePopup() {
  showSharePopup.value = false;
}

async function parseInvitationCodeFromScan(rawValue) {
  const value = String(rawValue || "").trim();
  if (!value) {
    return "";
  }
  if (value.includes("r=")) {
    const part = value.split("r=")[1] || "";
    return (part.split("&")[0] || "").trim();
  }
  if (value.includes("&friend")) {
    const targetAddress = (value.split("&friend")[0] || "").trim();
    if (!targetAddress) {
      return "";
    }
    const result = await userGetUserInfoByAddress({
      address: targetAddress,
      targetAddress,
    });
    return String(result?.invitationCode || "").trim();
  }
  return (value.split("&")[0] || "").trim();
}

async function bindParent() {
  const code = String(parentCode.value || "").trim();
  if (!code || isBound.value) {
    return;
  }

  showLoadingToast({
    message: t("common.submitting"),
    forbidClick: true,
    duration: 0,
  });

  try {
    await ptBindParent({
      address: profileStore.platformAddress || null,
      invitationCode: code,
    });
    await loadPageData();
  } catch (error) {
    showFailToast(error?.message || t("common.retryLater"));
  } finally {
    closeToast();
  }
}

async function loadPageData() {
  const address = profileStore.platformAddress || null;
  if (!address) {
    inviteOverview.value = {};
    referralDocument.value = {};
    parentCode.value = "";
    userNum.value = "--";
    rewardStore.reset();
    return;
  }

  try {
    const userInfo = await ptInfo(
      { address },
      { meta: { showLoading: false } },
    );
    userNum.value = String(userInfo?.userNum ?? "");
  } catch (_) {
    userNum.value = "";
  }

  try {
    inviteOverview.value =
      (await refOverview({
        address,
        lang: locale.value || profileStore.locale || "zh-CN",
      })) || {};
    if (Number(inviteOverview.value?.isBind || 0) === 1) {
      parentCode.value = String(
        inviteOverview.value?.parentInvitationCode || "",
      );
    }
  } catch (error) {
    inviteOverview.value = {};
    parentCode.value = "";
    showFailToast(error?.message || t("common.retryLater"));
  }

  try {
    await rewardStore.fetchNext({
      address,
      reset: true,
    });
  } catch (error) {
    rewardStore.reset();
  }
}

async function downloadQrCode() {
  const poster = invitePosterRef.value;
  if (!poster || !qrUrl.value) {
    return;
  }

  showLoadingToast({
    message: t("common.loading"),
    forbidClick: true,
    duration: 0,
  });

  try {
    await nextTick();
    await Promise.all(
      Array.from(poster.querySelectorAll("img")).map((image) =>
        image.complete
          ? Promise.resolve()
          : new Promise((resolve) => {
              image.addEventListener("load", resolve, { once: true });
              image.addEventListener("error", resolve, { once: true });
            }),
      ),
    );

    const { width, height } = poster.getBoundingClientRect();
    const canvas = await html2canvas(poster, {
      allowTaint: false,
      backgroundColor: "#edf5ff",
      width: Math.ceil(width),
      height: Math.ceil(height),
      imageTimeout: 15000,
      logging: false,
      scale: 2,
      useCORS: true,
    });
    const filename = `winpay-invite-${invitationCodeText.value || "poster"}.png`;
    const saved = await savePosterImage(canvas, filename);
    if (saved) {
      showSuccessToast(t("wallet.saveSuccess"));
    } else {
      showFailToast(t("wallet.saveFailed"));
    }
  } catch (error) {
    showFailToast(t("wallet.saveFailed"));
  } finally {
    closeToast();
  }
}

function canvasToBlob(canvas) {
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) {
        resolve(blob);
        return;
      }
      reject(new Error("Unable to create poster image"));
    }, "image/png");
  });
}

async function savePosterImage(canvas, filename) {
  const imageBlob = await canvasToBlob(canvas);
  const imageFile = new File([imageBlob], filename, { type: "image/png" });
  if (navigator.canShare?.({ files: [imageFile] })) {
    await navigator.share({ files: [imageFile], title: "WinPay" });
    return true;
  }

  const objectUrl = URL.createObjectURL(imageBlob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
  return true;
}

function formatRewardTime(timestamp) {
  return formatCardTimestamp(timestamp);
}

function syncNavBarState() {
  const scrollTop =
    window.scrollY ||
    document.documentElement.scrollTop ||
    document.body.scrollTop ||
    0;
  showNavSolid.value = scrollTop > 0;
}

function scrollPointsToLevel(index = 0) {
  const container = pointsCarouselRef.value;
  const children = container?.children || [];
  const target = children[index];
  if (!container || !target) {
    return;
  }

  const leftInset =
    Number.parseFloat(window.getComputedStyle(container).paddingLeft) || 0;

  container.scrollTo({
    left: Math.max(0, target.offsetLeft - leftInset),
    behavior: "auto",
  });
}

function handlePointsMouseDown(event) {
  if (event.button !== 0) {
    return;
  }

  const container = pointsCarouselRef.value;
  if (!container) {
    return;
  }

  pointsMouseState = {
    startX: event.clientX,
    startY: event.clientY,
    startScrollLeft: container.scrollLeft,
    horizontal: false,
  };
  window.addEventListener("mousemove", handlePointsMouseMove, true);
  window.addEventListener("mouseup", handlePointsMouseUp, true);
}

function handlePointsMouseMove(event) {
  const state = pointsMouseState;
  const container = pointsCarouselRef.value;
  if (!state || !container) {
    return;
  }

  const deltaX = event.clientX - state.startX;
  const deltaY = event.clientY - state.startY;
  if (!state.horizontal && Math.abs(deltaX) < 8 && Math.abs(deltaY) < 8) {
    return;
  }

  if (!state.horizontal) {
    if (Math.abs(deltaY) >= Math.abs(deltaX)) {
      releasePointsMouse();
      return;
    }
    state.horizontal = true;
    pointsDragging.value = true;
  }

  container.scrollLeft = state.startScrollLeft - deltaX;
  event.preventDefault();
}

function handlePointsMouseUp() {
  const state = pointsMouseState;
  if (!state) {
    return;
  }

  if (state.horizontal) {
    suppressPointsClick = true;
    window.clearTimeout(suppressPointsClickTimer);
    suppressPointsClickTimer = window.setTimeout(() => {
      suppressPointsClick = false;
    }, 250);
  }
  releasePointsMouse();
}

function releasePointsMouse() {
  window.removeEventListener("mousemove", handlePointsMouseMove, true);
  window.removeEventListener("mouseup", handlePointsMouseUp, true);
  pointsMouseState = null;
  pointsDragging.value = false;
}

function handlePointsClickCapture(event) {
  if (!suppressPointsClick) {
    return;
  }

  window.clearTimeout(suppressPointsClickTimer);
  suppressPointsClick = false;
  event.preventDefault();
  event.stopPropagation();
}

function handlePointsResize() {
  syncPopupViewport();
  scrollPointsToLevel(currentLevelIndex.value);
}

watch(
  () => pageState.value.scanResult,
  async (value) => {
    const rawValue = String(value || "").trim();
    if (!rawValue || rawValue === handledScanValue.value || isBound.value) {
      return;
    }
    handledScanValue.value = rawValue;
    navigateWithState(router, route.path, {
      namespace: "wallet-invite",
      replace: true,
      payload: {
        ...pageState.value,
        scanResult: "",
      },
    });
    const code = await parseInvitationCodeFromScan(rawValue);
    if (!code || isBound.value) {
      return;
    }
    parentCode.value = code;
    await bindParent();
  },
  { immediate: true },
);

watch(
  invitationLink,
  async (value) => {
    if (!value || value === "--") {
      qrUrl.value = "";
      return;
    }
    try {
      qrUrl.value = await QRCode.toDataURL(value, {
        margin: 1,
        width: 220,
      });
    } catch (error) {
      qrUrl.value = "";
    }
  },
  { immediate: true },
);

watch(
  currentLevelIndex,
  async (value) => {
    await nextTick();
    scrollPointsToLevel(value);
  },
  { immediate: true },
);

onMounted(() => {
  loadPageData();
  loadReferralDocument().catch(() => {
    referralDocument.value = {};
  });
  syncPopupViewport();
  syncNavBarState();
  window.addEventListener("scroll", syncNavBarState, { passive: true });
  window.addEventListener("resize", handlePointsResize, { passive: true });
  window.visualViewport?.addEventListener("resize", syncPopupViewport, {
    passive: true,
  });
});

onUnmounted(() => {
  window.removeEventListener("scroll", syncNavBarState);
  window.removeEventListener("resize", handlePointsResize);
  window.visualViewport?.removeEventListener("resize", syncPopupViewport);
  window.clearTimeout(suppressPointsClickTimer);
  if (pointsMouseState) {
    releasePointsMouse();
  }
});
</script>

<style scoped lang="scss">
.invite-page {
  min-height: var(--app-viewport-height);
  padding-bottom: calc(124px + env(safe-area-inset-bottom));
  background: #f7f8fa;
  overflow-x: hidden;
}

:deep(.invite-page__nav.van-nav-bar) {
  z-index: 10;
  transition: background-color 0.2s ease;
}

.invite-page__nav-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  background: transparent;

  .app-image {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }
}

.invite-hero {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  height: 450px;
  padding: calc(var(--van-nav-bar-height) + env(safe-area-inset-top)) 16px 0;
  overflow: hidden;
  background: #fff;
}

.invite-hero::before {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: 310px;
  background: url("@/assets/images/homeImage/invite_bg.png") center top / cover
    no-repeat;
  content: "";
}

.invite-hero--compact {
  height: 430px;
}

.invite-hero--compact::before {
  height: 290px;
}

.invite-hero__content {
  position: relative;
  z-index: 1;
  max-width: 210px;
}

.invite-hero__rules {
  padding: 0;
  border: 0;
  border-bottom: 1px solid #f7811a;
  background: transparent;
  color: #f7811a;
  font-size: 14px;
  line-height: 20px;
}

.invite-hero__title {
  margin: 5px 0 5px;
  color: #ffffff;
  font-size: 22px;
  line-height: 31px;
  font-weight: 700;

  .price {
    color: #f7dd1a;
    margin-right: 10px;
  }
}

.invite-hero__desc {
  margin: 0;
  color: #dedede;
  font-size: 14px;
  line-height: 20px;
}

.invite-hero__claim {
  position: absolute;
  right: 14px;
  bottom: 18px;
  left: 14px;
  z-index: 1;
  color: #999999;
}

.invite-hero__claim-label {
  font-size: 13px;
  line-height: 22px;
}
.van-button--disabled {
  background: #f4f5f6 !important;
  color: #999 !important;
  font-weight: 500 !important;
}

.invite-hero__claim-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 2px;

  [data-strong] {
    font-size: 20px;
  }

  .invite-hero__claim-button {
    position: absolute;
    top: 46%;
    right: 0;
    display: inline-flex;
    align-items: center;
    height: 32px;
    justify-content: center;
    padding: 6px 22px;
    border-radius: 24px;
    border: 0;
    font-size: 14px;
    text-align: center;
    transform: translateY(-50%);
  }
}

.invite-hero > .app-image {
  position: relative;
  z-index: 1;
  width: 132px;
  margin-top: 20px;
  object-fit: contain;
}

.invite-card-bg {
  position: relative;
  display: flex;
  box-sizing: border-box;
  margin-top: 12px;
  padding: 14px 18px 12px;
  overflow: hidden;
  border-radius: 14px;
  aspect-ratio: 1125 / 306;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.invite-card-bg__content {
  position: relative;
  z-index: 1;
  max-width: 220px;
}

.invite-card-bg__title {
  color: #2f66ff;
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
}

.invite-card-bg__button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: max-content;
  margin-top: 12px;
  padding: 1px 14px;
  box-sizing: border-box;
  border-radius: 4px;
  position: relative;
  z-index: 0;
  isolation: isolate;
  background: transparent;
  color: #ffffff;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;

  &::before {
    position: absolute;
    z-index: -1;
    inset: 0;
    border-radius: 4px;
    background: linear-gradient(90deg, #2f66ff 0%, #14b9ed 100%);
    content: "";
    pointer-events: none;
    transform: skewX(-10deg);
  }

  .van-icon {
    margin-left: 4px;
    font-size: 15px;
  }
}

@media (max-width: 360px) {
  .invite-card-bg {
    padding-right: 14px;
    padding-left: 14px;
  }

  .invite-card-bg__content {
    max-width: 190px;
  }

  .invite-card-bg__title {
    font-size: 15px;
    line-height: 21px;
  }
}

.invite-card {
  margin: 10px 14px 0;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
}

.points-card {
  position: absolute;
  right: 0;
  bottom: 80px;
  left: 0px;
  box-sizing: border-box;
  z-index: 1;
  overflow: hidden;
}

.points-card__carousel {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  overflow-y: hidden;
  padding-right: 16px;
  padding-left: 14px;
  padding-bottom: 0px;
  scroll-padding-left: 14px;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

@media (hover: hover) and (pointer: fine) {
  .points-card__carousel {
    cursor: grab;
    user-select: none;
  }

  .points-card__carousel.is-dragging {
    cursor: grabbing;
    scroll-snap-type: none;
  }
}

.points-card__item {
  flex: 0 0 calc(100% - 0px);
  width: calc(100% - 16px);
  padding-bottom: 6px;
  box-sizing: border-box;
  scroll-snap-align: start;
}

.points-level {
  display: flex;
  align-items: center;
  .hint {
    font-size: 16px;
  }
}

.points-level--hidden {
  visibility: hidden;
}

.points-level-card {
  position: relative;
  // min-height: 157px;
  width: 100%;
  font-size: 13px;
  border-radius: 16px;
  overflow: hidden;
  &_list {
    display: flex;
    min-width: 0;
    justify-content: space-between;
  }

  &_item {
    display: flex;
    gap: 10px;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  &_item-label {
    position: relative;
    display: block;
    line-height: 18px;
    font-size: 11px;
    text-align: center;
  }

  &_item-icon {
    position: absolute;
    top: 50%;
    left: calc(100% + 3px);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    box-sizing: border-box;
    border: 1px solid currentColor;
    border-radius: 50%;
    font-family: Arial, sans-serif;
    font-size: 12px;
    font-weight: 700;
    font-style: normal;
    line-height: 1;
    color: currentColor;
    transform: translateY(-50%);
  }

  &_item > div:last-child {
    width: 100%;
    line-height: 18px;
    font-weight: 700;
    text-align: center;
  }
}

.points-level-card__tag {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  padding: 5px 8px;
  border-radius: 0 16px 0 4px;
  font-size: 12px;
  line-height: 1;
}

.points-level-card__body {
  display: flex;
  flex-direction: column;
  padding: 16px 20px 20px;
  box-sizing: border-box;
}

.points-level-card__title {
  display: flex;
  align-items: flex-start;
  gap: 6px;

  [data-strong] {
    display: block;
    font-size: 14px;
    font-weight: 700;
    line-height: 19px;
    white-space: nowrap;
  }
}

.points-level-card__join {
  margin-top: 0px;
  margin-left: 8px;
  padding: 3px 16px;
  border: 0;
  border-radius: 16px;
  background: #716b5f;
  color: #ffeaa3;
  font-size: 12px;
  text-align: center;
  white-space: nowrap;
}

.points-level-card__desc-wrap {
  position: relative;
  min-height: 42px;
  margin: 17px 0 0;
}

.points-level-card__desc {
  max-width: calc(100% - 32px);
  margin: 0;
  font-size: 14px;
  line-height: 20px;
}

.points-level-card__icon {
  width: 23px;
  height: 19px;
  flex: 0 0 23px;
  object-fit: contain;

  :deep(.van-image__img) {
    object-fit: contain;
  }
}

.points-level-card__bar {
  height: 4px;
  width: 87%;
  margin-right: 10px;
  border-radius: 999px;
  // overflow: hidden;

  i {
    display: block;
    height: 100%;
    border-radius: 999px;
    background: #2c6bff;
  }
}

.points-level-card__foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}

.points-level-card_item-value--zero {
  text-decoration: underline;
  text-decoration-thickness: 2px;
  text-underline-offset: 4px;
}

.points-card__desc-wrap {
  position: relative;
  min-height: 40px;
}

.points-card__desc {
  margin: 18px 42px 14px 0;
  color: #48486c;
  font-size: 14px;
  line-height: 20px;
}

.points-card--lv2 .points-card__desc {
  color: #3d4f73;
}

.points-card--lv3 .points-card__desc {
  color: #6b5a44;
}

.points-card--lv4 .points-card__desc {
  color: rgba(255, 234, 163, 0.88);
}

.points-card__icon {
  position: absolute;
  right: 0;
  top: 8px;
  width: 23px;
  height: 23px;
  object-fit: contain;
}

.points-card__bar {
  height: 4px;
  border-radius: 999px;
  background: #cfdcff;
  overflow: hidden;

  i {
    display: block;
    height: 100%;
    border-radius: 999px;
    background: #2c6bff;
  }
}

.points-card--lv2 .points-card__bar {
  background: #d7ebff;

  i {
    background: #234796;
  }
}

.points-card--lv3 .points-card__bar {
  background: #f5dfba;

  i {
    background: #b15921;
  }
}

.points-card--lv4 .points-card__bar {
  background: rgba(255, 234, 163, 0.18);

  i {
    background: #ffeaa3;
  }
}

.points-card__foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;

  span {
    color: #999999;
    font-size: 12px;
  }

  button {
    padding: 0;
    border: 0;
    background: transparent;
    color: #2c6bff;
    font-size: 12px;
  }
}

.points-card--lv4 .points-card__foot span {
  color: rgba(255, 234, 163, 0.72);
}

.points-card--lv2 .points-card__foot button,
.points-card--lv3 .points-card__foot button {
  color: currentColor;
}

.points-card--lv4 .points-card__foot button {
  color: #ffeaa3;
}

.invite-card {
  box-sizing: border-box;
  width: 100%;
  padding: 18px 16px;
  margin: 10px auto 12px;
}

.invite-card--first {
  margin-top: 12px;
}

.invite-card__desc {
  margin: 0;
  color: #666666;
  font-size: 12px;
  line-height: 22px;
}

.card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;

  i {
    width: 4px;
    height: 18px;
    border-radius: 999px;
    background: #2667ff;
  }

  h2 {
    margin: 0;
    color: #000000;
    font-size: 16px;
    line-height: 22px;
    font-weight: 700;
  }
}

.invite-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 52px;
  margin-bottom: 12px;
  padding: 0 12px;
  border-radius: 10px;
  background: #f4f5f6;
  gap: 12px;
  font-size: 14px;
  > span {
    flex: 0 0 96px;
    color: #333333;

    white-space: nowrap;
  }
}

.invite-row--last {
  margin-bottom: 0;
}

.invite-row__value {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
  min-width: 0;
  gap: 5px;

  .value {
    overflow: hidden;
    color: #000;
    font-size: 16px;
    line-height: 22px;
    text-overflow: ellipsis;
    white-space: nowrap;
    letter-spacing: 0.5px;
    font-weight: 600;
  }

  button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 0;
    background: transparent;
  }

  .app-image {
    width: 18px;
    height: 18px;
  }
}

.invite-row__value--wide [data-strong] {
  max-width: 182px;
}

.invite-row__icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;

  .app-image {
    width: 20px;
    height: 20px;
  }
}

.invite-bind {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.invite-bind__field {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  padding-left: 12px;
  border-radius: 10px;
  background: #f4f5f6;

  > span {
    flex: 0 0 auto;
    color: #333333;
    font-size: 14px;
    white-space: nowrap;
  }

  :deep(.van-cell) {
    flex: 1;
    padding: 0 0 0 10px;
    background: transparent;
  }

  :deep(.van-field__control) {
    height: 44px;
    // color: #666;
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 0.5px;
  }
}

.invite-bind__field--bound {
  :deep(.van-field__control) {
    font-size: 16px;
    letter-spacing: 1px;
  }
}

.invite-bind__scan {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 40px;
  width: 40px;
  height: 44px;
  padding: 0;
  border: 0;
  background: transparent;
  position: relative;
  z-index: 1;

  .app-image {
    width: 20px;
    height: 20px;
  }
}

.invite-bind__button {
  flex: 0 0 84px;
  --van-button-border-radius: 10px;
  --van-button-primary-border-color: #d7e5ff;
  --van-button-primary-background: #d7e5ff;
  --van-button-primary-color: #2f66ff;
  border-radius: 12px;

  :deep(.van-button) {
    font-size: 16px;
    font-weight: 500;
    // border-radius: 16px;
  }

  :deep(.van-button--disabled.van-button--primary) {
    opacity: 1;
    border-color: #d7e5ff;
    background: #f4f5f6;
    color: #a9c1ff;
  }
}

.invite-bind__button--bound {
  --van-button-default-border-color: #f4f5f6;
  // --van-button-default-background: #f4f5f6;
  // --van-button-default-color: #999999;
  // background: #f4f5f6 !important;
  // color: #999 !important;
  font-weight: 500;

  :deep(.van-button) {
    border-color: #f4f5f6;
    background: #f4f5f6;
    color: #999999;
    border-radius: 16px;
  }

  :deep(.van-button--default) {
    border-color: #f4f5f6;
    background: #f4f5f6;
    color: #999999;
  }
}

.steps-card {
  // padding-bottom: 6px;
}

.reward-card-head {
  display: flex;
  align-items: center;
  // font-size: 16px;
  justify-content: space-between;
}

.reward-card-head__title {
  margin-bottom: 0;
}

.reward-card-head__more {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #2667ff;
  font-size: 14px;

  .app-image {
    width: 10px;
    height: 10px;
    object-fit: contain;
    filter: brightness(0) saturate(100%) invert(33%) sepia(94%) saturate(4438%)
      hue-rotate(220deg) brightness(101%) contrast(101%);
  }
}

.reward-preview__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 0;
  border-bottom: 1px solid #f4f5f6;

  &:last-child {
    padding-bottom: 0;
    border-bottom: 0;
  }

  [data-strong],
  span {
    display: block;
  }

  > div:first-child [data-strong] {
    color: #333;
    font-size: 16px;
    line-height: 22px;
    font-weight: 500;
  }

  > div:first-child span {
    margin-top: 4px;
    color: #999;
    font-size: 14px;
    line-height: 20px;
  }
}

.reward-preview-list {
  margin-top: 14px;
}

.reward-preview__amount {
  text-align: right;

  [data-strong] {
    color: #2667ff;
    font-size: 16px;
    line-height: 22px;
    font-weight: 700;
  }

  span {
    margin-top: 4px;
    color: #999;
    font-size: 14px;
    line-height: 20px;
  }
}

.reward-preview--empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0 0;
  color: #999;

  .app-image {
    width: 160px;
  }
}

.invite-reward-summary__list {
  margin-top: 14px;
}

.step-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 4px;

  span {
    flex: 1;
    padding-top: 2px;
    color: #333333;
    font-size: 14px;
    line-height: 20px;
  }
}

.step-row--last {
  margin-bottom: 0;
}

.step-row__icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 0 0 20px;

  .app-image {
    width: 20px;
    height: 20px;
  }

  b {
    width: 1px;
    height: 30px;
    margin: 6px 0 2px;
    border-left: 1px dashed #2667ff;
  }
}

.invite-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 5;
  padding: 10px 14px calc(20px + env(safe-area-inset-bottom));
  background: #ffffff;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.08);
  font-weight: bold;
  font-size: 16px;
  .flex {
    flex: 0.8;
  }
  &__url {
    flex: 1.2;
    align-items: center;
    gap: 8px;
    background: #eef4ff;
    padding: 15px 12px;
    display: flex;
    flex-wrap: nowrap;
    font-size: 12px;
    color: #666;
    border-radius: 8px;
    cursor: pointer;
    .url {
      display: flex;
      gap: 4px;
    }
    .nowrap {
      // min-width: 47px;
      white-space: nowrap;
    }
  }
  &__url-icon {
    display: block;
    flex: 0 0 16px;
    width: 16px;
    height: 16px;
    pointer-events: none;
  }
  &__url-list {
    display: flex;
    gap: 4px;
    margin-bottom: 10px;

    .label {
      flex: 1;
      // white-space: nowrap;
    }
    .black {
      color: #000;
    }
  }
}

:global(.purchase-commission-popup.van-popup--bottom) {
  width: var(--app-shell-width);
  max-width: 100vw;
  left: var(--app-shell-left);
  right: auto;
  overflow: hidden;
  border-radius: 24px 24px 0 0;
  background: #ffffff;
}

:global(.purchase-commission-popup.van-popup--center),
:global(.consumption-commission-popup.van-popup--center) {
  width: calc(100% - 24px);
  max-width: 344px;
  max-height: calc(100vh - 48px);
  left: var(--app-shell-left) !important;
  right: calc(
    100vw - var(--app-shell-left) - var(--app-shell-width)
  ) !important;
  margin: 0 auto !important;
  transform: translateY(-50%) !important;
  overflow: hidden;
  border-radius: 24px;
  background: #ffffff;
}

:global(.purchase-commission-overlay) {
  width: var(--app-shell-width);
  max-width: 100vw;
  left: var(--app-shell-left);
  right: auto;
}

.purchase-commission-dialog {
  padding: 24px 24px 28px;
  overflow-y: auto;
  box-sizing: border-box;
  background: #ffffff;

  h2 {
    margin: 0;
    color: #000;
    font-size: 18px;
    font-weight: 700;
  }

  &__intro {
    margin: 10px 0 14px;
    color: #000;
    font-size: 16px;
    font-weight: 500;
  }

  &__item {
    position: relative;
    padding-left: 16px;

    &::before {
      position: absolute;
      top: 5px;
      left: 0;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: #000000;
      content: "";
    }

    h3 {
      margin: 0;
      color: #333333;
      font-size: 15px;
      font-weight: 400;
    }

    p {
      margin: 2px 0 10px;
      color: #333333;
      font-size: 15px;
    }
  }

  &__item--inline p {
    margin: 0 0 10px;
    line-height: 24px;
  }

  &__emphasis {
    color: #000000;
    font-weight: 700;
  }

  &__time {
    font-weight: 700;
  }

  &__confirm {
    margin-top: 20px;
    border: 0;
    background: #2667ff;
    font-size: 18px;
    font-weight: 500;
  }
}

:global(.invite-poster-popup.van-popup--center) {
  top: calc(env(safe-area-inset-top) + 16%) !important;
  left: var(--app-shell-left) !important;
  right: calc(
    100vw - var(--app-shell-left) - var(--app-shell-width)
  ) !important;
  width: min(calc(var(--app-shell-width) - 32px), 290px) !important;
  margin: 0 auto !important;
  overflow: hidden;
  border-radius: 16px;
  background: #edf5ff;
  transform: none !important;
}

:global(.invite-poster-overlay) {
  width: var(--app-shell-width);
  max-width: 100vw;
  left: var(--app-shell-left);
  right: auto;
}

.invite-poster {
  position: relative;
  width: 100%;
  height: 340px;
  overflow: hidden;
  background: #edf5ff;
}

.invite-poster__art {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.invite-poster__logo {
  position: absolute;
  top: 18px;
  left: 16px;
  width: 100px;
  height: auto;
}

.invite-poster__title {
  position: absolute;
  top: 68px;
  right: 12px;
  left: 12px;
  margin: 0;
  color: #000000;
  font-size: 22px;
  font-weight: 700;
  line-height: 30px;
  text-align: center;
}

.invite-poster__code {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  min-height: 82px;
  padding: 10px 14px;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.95);
}

.invite-poster__code-main {
  flex: 1;
  min-width: 0;

  > div:first-child {
    display: flex;
    align-items: baseline;
    min-width: 0;
    color: #000000;
    font-size: 14px;

    > span {
      flex: 0 0 auto;
      white-space: nowrap;
    }
  }

  p {
    margin: 4px 0 0;
    color: #999999;
    font-size: 12px;
  }
}

.invite-poster__code-value {
  flex: 1 1 auto;
  min-width: 0;
  // overflow: hidden;
  color: #000000;
  font-size: 15px;
  font-weight: 700;
  // text-overflow: ellipsis;
  // white-space: nowrap;
}

.invite-poster__qrcode {
  display: flex;
  flex: 0 0 58px;
  align-items: center;
  justify-content: center;
  width: 58px;
  height: 58px;
  margin-left: 8px;
  padding: 3px;
  border-radius: 6px;
  background: #ffffff;
  box-shadow: 0 0 0 2px #edf3ff;
  box-sizing: border-box;

  .app-image {
    width: 100%;
    height: 100%;
  }
}

:global(.share-popup.van-popup--bottom) {
  width: var(--app-shell-width);
  max-width: 100vw;
  left: var(--app-shell-left);
  right: auto;
  overflow: hidden;
  border-radius: 24px 24px 0 0;
  background: #ffffff;
}

.share-popup {
  padding-bottom: calc(18px + env(safe-area-inset-bottom));
  background: #ffffff;
}

.share-popup__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 19px 24px 30px;

  > span,
  button {
    width: 24px;
    height: 24px;
  }

  h3 {
    margin: 0;
    color: #111111;
    font-size: 20px;
    font-weight: 500;
  }

  button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 0;
    background: transparent;
  }

  .app-image {
    width: 22px;
    height: 22px;
  }
}

.share-popup__rows {
  display: grid;
  gap: 12px;
  padding: 0 22px;
}

.share-popup__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px 17px;
  border-radius: 12px;
  border: 1px solid #f4f5f6;

  > span {
    color: #666666;
    font-size: 16px;
  }

  > div {
    display: flex;
    align-items: center;
    min-width: 0;
    margin-left: 12px;
  }

  button {
    display: inline-flex;
    flex: 0 0 22px;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    margin-left: 8px;
    padding: 0;
    border: 0;
    background: transparent;
  }

  .app-image {
    width: 22px;
    height: 22px;
  }
}

.share-popup__value {
  overflow: hidden;
  color: #333333;
  font-size: 18px;
  font-weight: 500;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.share-popup__actions {
  display: flex;
  justify-content: center;
  gap: 62px;
  margin-top: 20px;

  .share-popup__icon {
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
    border: 0;
    gap: 10px;
    background: transparent;
    color: #333333;
    font-size: 16px;
    font-weight: 400;
  }

  .share-popup__icon > span {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #f4f4f4;
  }

  :deep(.van-icon) {
    color: #000000;
    font-size: 24px;
  }
}

:global(.invite-poster-popup--compact.van-popup--center) {
  top: calc(env(safe-area-inset-top) + 5%) !important;
  width: min(calc(var(--app-shell-width) - 32px), 290px) !important;
}

:global(.invite-poster-popup--compact .invite-poster) {
  height: 325px;
}

.share-popup--compact {
  padding-bottom: calc(14px + env(safe-area-inset-bottom));
}

.share-popup--compact .share-popup__header {
  padding: 15px 20px 12px;

  h3 {
    font-size: 19px;
  }
}

.share-popup--compact .share-popup__rows {
  gap: 10px;
  padding: 0 20px;
}

.share-popup--compact .share-popup__row {
  padding: 14px 14px 17px;
  border-radius: 11px;

  > span {
    font-size: 15px;
  }
}

.share-popup--compact .share-popup__value {
  font-size: 17px;
}

.share-popup--compact .share-popup__actions {
  gap: 56px;
  margin-top: 18px;

  button {
    gap: 8px;
    font-size: 15px;
  }

  button > span {
    width: 48px;
    height: 48px;
  }

  :deep(.van-icon) {
    font-size: 28px;
  }
}
</style>
